export default __webpack_public_path__ + "static/media/PipePole.256.25ec6ccb.png";